export default __webpack_public_path__ + "static/media/gallery_02.14cd74b0.jpg";